import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button, Badge } from "react-bootstrap";
import { FaSearch, FaTimes, FaUser, FaKey, FaCalendarAlt } from "react-icons/fa";
import Pagination from "../../helper/Pagination";
import { getTrackUsage } from "../../redux/actions/settingActions";

const TrackModal = ({ show, onHide, selectedLicense }) => {
  const dispatch = useDispatch();
  const {
    trackUsage = [],
    trackUsageLoading = false,
    trackUsageError = null,
    trackUsagePagination = {},
  } = useSelector((state) => state.setting || {});

  const [modalSearchTerm, setModalSearchTerm] = useState("");
  const [modalCurrentPage, setModalCurrentPage] = useState(1);

  const handleModalSearchChange = (e) => {
    setModalSearchTerm(e.target.value);
    setModalCurrentPage(1);
  };

  const handleModalPageChange = (page) => {
    setModalCurrentPage(page);
  };

  useEffect(() => {
    if (show && selectedLicense) {
      const userData = JSON.parse(sessionStorage.getItem('user') || '{}');
      const itsalesId = userData?.itSalesPartner?.id;
      
      if (itsalesId) {
        dispatch(getTrackUsage({
          licenseId: selectedLicense._id,
          itsalesId: itsalesId,
          search: modalSearchTerm,
          page: modalCurrentPage,
          limit: 10
        }));
      }
    }
  }, [dispatch, show, selectedLicense, modalSearchTerm, modalCurrentPage]);

  const handleClose = () => {
    setModalSearchTerm("");
    setModalCurrentPage(1);
    onHide();
  };
const capitalize = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
  return (
    <Modal 
      show={show} 
      onHide={handleClose} 
      size="xl" 
      centered
      className="modern-modal"
    >
      <div className="modal-content" style={{
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
        overflow: 'hidden'
      }}>
        <div className="form-header-AllCoupon d-flex justify-content-between align-items-center" style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '10px',
          marginBottom: '0',
          border: 'none'
        }}>
          <div>
            <h5 className="mb-1 text-white">
              <FaKey className="me-2 text-white" />
              License Usage Details
            </h5>
            <p className="text-white mb-0">
              Track and monitor license utilization
            </p>
          </div>
          <button
            type="button"
            className="btn-close"
            onClick={handleClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '16px',
              cursor: 'pointer',
              color: 'white'
            }}
          >
            <FaTimes />
          </button>
        </div>
        
        <div className="table-section" style={{ padding: '10px', background: 'white' }}>
          {selectedLicense && (
            <div className="mb-4" style={{
              background: 'linear-gradient(135deg, #f8f9ff 0%, #f0f2ff 100%)',
              borderRadius: '12px',
              padding: '10px 12px',
              border: '1px solid #e8ecff'
            }}>
              <div className="row align-items-center">
                <div className="col-md-8">
                  <div className="d-flex align-items-center mb-2">
                    <FaUser className="me-2" style={{ color: '#667eea' }} />
                    <h6 className="mb-0" style={{ fontWeight: '600', color: '#2d3748' }}>License Name: {capitalize(selectedLicense.name)}</h6>
                  </div>
                  <div className="d-flex align-items-center">
                    <FaKey className="me-2" style={{ color: '#667eea', fontSize: '12px' }} />
                    <small style={{ color: '#718096', fontFamily: 'monospace' }}>
                      {selectedLicense.licenseKey}
                    </small>
                  </div>
                </div>
                <div className="col-md-4 text-end">
                  <div className="d-flex flex-column align-items-end">
                    <Badge 
                      bg={selectedLicense.status === 'active' ? 'success' : 'danger'}
                      style={{
                        fontSize: '12px',
                        padding: '6px 12px',
                        borderRadius: '20px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}
                    >
                      {selectedLicense.status}
                    </Badge>
                  </div>
                </div>
              </div>
            </div>
          )}
          
          <div className="d-flex justify-content-between align-items-center mb-1">
            <div className="d-flex align-items-center gap-2">
              <h6 className="mb-0">Usage Analytics :</h6>
              <span className="text-dark">{trackUsage.length} items</span>
            </div>
            <div className="position-relative d-flex justify-content-end mb-1">
              <input
                type="search"
                placeholder="Search usage..."
                className="form-input"
                value={modalSearchTerm}
                onChange={handleModalSearchChange}
                style={{ width: "200px" }}
              />
              {modalSearchTerm === "" && (
                <div
                  className="position-absolute"
                  style={{
                    top: "50%",
                    right: "13px",
                    transform: "translateY(-50%)",
                    color: "#666",
                  }}
                >
                  <FaSearch />
                </div>
              )}
            </div>
          </div>

          <div className="table-scroll-wrapper">
            <table className="partners-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>User Details</th>
                  <th>Email</th>
                  <th>OEM Company</th>
                  <th>Domain</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                {trackUsageLoading ? (
                  <tr>
                    <td colSpan="12" style={{ textAlign: "center", padding: "40px", color: "#666" }}>
                      <div className="loading-spinner">
                      </div>
                    </td>
                  </tr>
                ) : trackUsageError ? (
                  <tr>
                    <td colSpan="12" style={{ textAlign: "center", padding: "20px", color: "#d32f2f" }}>
                      Error: {trackUsageError}
                    </td>
                  </tr>
                ) : trackUsage.length === 0 ? (
                  <tr>
                    <td colSpan="12" style={{ textAlign: "center", padding: "20px", color: "#666" }}>
                      No usage data available
                    </td>
                  </tr>
                ) : (
                  trackUsage.map((usage, index) => (
                    <tr key={index} className="table-row-hover">
                      <td>{(modalCurrentPage - 1) * 10 + index + 1}</td>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="coupon-icon me-2">
                            <FaUser className="text-primary" />
                          </div>
                          <div>
                            <div className="fw-bold text-primary">
                              {`${usage.firstName} ${usage.lastName}` || "N/A"}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>{usage.userEmail || "N/A"}</td>
                      <td>{usage.oemCompany || "N/A"}</td>
                      <td>
                        <span className="badge bg-light text-dark border">
                          {usage.domain || "N/A"}
                        </span>
                      </td>
                      <td>
                        <span className="text-capitalize fw-medium">
                          {usage.createdAt
                            ? new Date(usage.createdAt).toLocaleDateString()
                            : "N/A"}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {trackUsage.length > 0 && (
            <div className="mt-4">
              <Pagination
                currentPage={modalCurrentPage}
                totalPages={trackUsagePagination.totalPages || 1}
                totalItems={trackUsagePagination.totalItems || 0}
                itemsPerPage={10}
                onPageChange={handleModalPageChange}
              />
            </div>
          )}
        </div>
        
        <div className="modal-footer" style={{
          background: '#f8fafc',
          border: 'none',
          padding: '10px',
          borderTop: '1px solid #e2e8f0'
        }}>
          <div className="d-flex justify-content-between align-items-center w-100">
            <div className="text-muted" style={{ fontSize: '14px' }}>
              {trackUsage.length > 0 && (
                <span>Showing {trackUsage.length} of {trackUsagePagination.totalItems || 0} entries</span>
              )}
            </div>
            {/* <Button 
              onClick={handleClose}
              className="cancel-btn"
            >
              Close
            </Button> */}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TrackModal;